import styled from 'styled-components';
import {tokens} from "../../../theme";

export const StyledDigitizationPage = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`;

interface MainContainerProps {
    $row?: boolean;
}

export const StyledDigitizationCard = styled.div<MainContainerProps>`
    display: flex;
    flex: 1;
    flex-direction: ${({$row}) => $row ? 'row' : 'column'};
    min-height: 0;
    overflow: auto;

    border-radius: ${tokens.radius['4xl']};
    border: 1px solid  ${({theme}) => theme.palette.dividers.subtle};
    background-color: ${({theme}) => theme.palette.background.paper};
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
`;

export const StyledDigitizationContent = styled.div`
    display: flex;
    flex: 1;
    align-items: flex-start;
    justify-content: center;
    padding: 0 32px 28px;
    min-height: 0;
    overflow: auto;
`;